import {Component, Input, OnInit} from '@angular/core';
import {EntidadeConfig, EntidadeEnum} from 'src/app/api/module/erp/shared/enumerable/entidade.enum';
import {TipoProduto_E_OperadoraComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-documento-reajuste-udemo',
  templateUrl: './documento-reajuste-udemo.component.html',
  styleUrls: ['./documento-reajuste-udemo.component.scss'],
})
export class DocumentoReajusteUdemoComponent implements OnInit {
  @Input() entidadeProposta: any;
  @Input() razaoSocialEntidade: any;
  @Input() codigoProposta: any;
  @Input() vigenciaProposta: any;
  @Input() dadosOperadoraCabecalho!: any;
  @Input() dadosOperadoraDM!: any;
  @Input() nomeTitular: string;
  @Input() cpfTitular: string;

  operadoraVM: any;
  udemo_e_apase: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.operadoraVM = this.carregarDadosOperadoraReducaoCarencia();
  }

  carregarDadosOperadoraReducaoCarencia(): string {
    const entidadeConfig = EntidadeConfig.getConfig(this.dadosOperadoraDM.branchCompanyName || '');

    this.udemo_e_apase = entidadeConfig.tipo == EntidadeEnum.UDEMO || entidadeConfig.tipo == EntidadeEnum.APASE;

    const cnpjOperadoraFiltro = this.dadosOperadoraDM?.operatorObject && this.dadosOperadoraDM?.operatorObject?.cnpj;
    if (!cnpjOperadoraFiltro) {
      return '../../../../../../assets/app-assets/images/logos-empresas/default.png';
    }

    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    return dadosOperadora;
  }
}
